
LANG.getPluralTag = function (value) {
    var i = parseInt(value);
    var v = ("" + value).indexOf('.');
    var f = 0;
    var t = 0;
    var w = 0;
    var z = i + w;
    /* Pour utiliser i et w et que la compression ne supprime pas ces variables*/
    if (v != -1) {
        v = ("" + value).length - (v - 1);
        f = ("" + value).replace(/[\s0]*((\S+\s*)*)/, "$1").substr(v * -1);
        t = f.replace(/((\s*\S+)*)[\s0]*/, "$1");
        w = t.length;
    }
    else {
        v = 0;
    }


    if (typeof LANG != 'undefined') {
        if (typeof LANG.__currentLang == 'undefined') {
            LANG.__currentLang = $('meta[http-equiv="content-language"]').attr('content');
        }

        if (typeof LANG.__pluralRules != 'undefined' && typeof LANG.__pluralRules[LANG.__currentLang] != 'undefined') {
            for (var tag in LANG.__pluralRules[LANG.__currentLang]) {
                try {
                    if (eval(LANG.__pluralRules[LANG.__currentLang][tag])) {
                        return tag;
                    }
                }
                catch (e) {
                    console.warn(e);
                }
            }
        }
    }

    return 'other';
}


/**
 * Retourne le texte associé au code passé en paramètre. Si le code n'existe pas, la valeur retournée est le code précédé de "** : "
 *
 * - Si le code contient des termes à remplacer sous forme de "{x}", ils doivent être renseignés dans les paramètres qui suivent.
 * - Dans le cas de codes avec des variantes plurielles, la valeur du paramètre aussitôt après le code est prise en compte pour récupérer la variante correspondante.
 *
 * @param code string Chaine à trouver
 * @param args mixed [optional] (paramètres)
 * @return string
 */
function gettext(code, args) {
    return __(code, args)
}

/**
 * Retourne le texte associé au code passé en paramètre. Si le code n'existe pas, la valeur retournée est le code précédé de "** : "
 *
 * - Si le code contient des termes à remplacer sous forme de "{x}", ils doivent être renseignés dans les paramètres qui suivent.
 * - Dans le cas de codes avec des variantes plurielles, la valeur du paramètre aussitôt après le code est prise en compte pour récupérer la variante correspondante.
 *
 * @param code string Chaine à trouver
 * @param args mixed [optional] (paramètres)
 * @return string
 */
function __(code, args) {
    // On transforme la liste des arguments en un tableau, sans le 1er (le code).
    data = Array.prototype.slice.call(arguments, 1);

    // remplace {n} dans str par l'attribut "n" de l'objet data
    var interpolate = function (str, data) {
        if (data.length) {
            return str.replace(/\{(.*?)\}/g, function (match, id) {
                if (id in data) {
                    return data[id];
                }

                return "";
            });
        }

        return str;
    };

    var plurialGroups = function (data) {
        var result = [];
        if (data && typeof data[0] != 'undefined') {
            var v = parseFloat(data[0]);
            if (!isNaN(v)) {
                if (v == 0) {
                    result.push("zero");
                }
                if (v < 0) {
                    result.push("neg");
                }
                result.push(LANG.getPluralTag(v));
            }
            else if (!v) {
                result.push("zero");
            }
        }

        if ($.inArray('other', result) == -1) {
            result.push("other");
        }
        return result;
    }


    if (code.indexOf('.') == -1) {
        if (code.indexOf('/') == -1) {
            var grps = plurialGroups(data);
            for (var i = 0; i < grps.length; i++) {
                var gCode = code + '/' + grps[i];

                if (typeof LANG[gCode] != 'undefined') {
                    return interpolate(LANG[gCode], data);
                }
            }
        }
        else {
            code = code.substr(0, code.indexOf('/')) + code.substr(code.indexOf('/')).toLowerCase();
        }
        if (typeof LANG[code] != 'undefined') {
            return interpolate(LANG[code], data);
        }
    } else {
        var table = code.split('.');
        var tmpLang = LANG;
        var subCode;
        for (var key in table) {
            subCode = table[key];
            if (typeof tmpLang[subCode] == 'undefined') {
                return '** : ' + code;
            }

            if (key < table.length - 1) {
                tmpLang = tmpLang[subCode];
            }
        }

        if (subCode.indexOf('/') == -1) {
            var grps = plurialGroups(data);
            for (var i = 0; i < grps.length; i++) {
                var gCode = subCode + '/' + grps[i];

                if (typeof tmpLang[gCode] != 'undefined') {
                    return interpolate(tmpLang[gCode], data);
                }
            }
        }
        return interpolate(tmpLang[subCode], data);

    }

    if (code.indexOf('/') == -1) {
        var grps1 = plurialGroups(data);
        for (var j = 0; j < grps1.length; j++) {
            var gtmpCode = code + '/' + grps1[j];

            if (typeof LANG[gtmpCode] != 'undefined') {
                return interpolate(LANG[gtmpCode], data);
            }
        }
    }
    else {
        code = code.substr(0, code.indexOf('/')) + code.substr(code.indexOf('/')).toLowerCase();
    }

    if (typeof LANG[code] != 'undefined') {
        return interpolate(LANG[code], data);
    }

    return '** : ' + code;
}

